module.exports = __webpack_public_path__ + "static/20200811_111632-55c0cec35af8a3acc1f02c1584eb39b9.jpg";